import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class OfficeSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = {
      main: this.dom.el.querySelector('[data-js="office-slide-main"]'),
      thumbnail: this.dom.el.querySelector('[data-js="office-slide-thumbnail"]'),
    }

    this.slider = {
      main: null,
      thumbnail: null,
    }

    this.option = {
      main: {
        type: 'loop',
        // gap: `min(${10 / 16}rem, ${10 / 360 * 100}vw)`,
        rewind: true,
        arrows: false,
        pagination: false,
        focus: 'center',
      },
      thumbnail: {
        type: 'loop',
        autoWidth: true,
        gap: `min(${4 / 16}rem, ${4 / 360 * 100}vw)`,
        rewind: true,
        arrows: false,
        pagination: false,
        isNavigation: true,
        // padding: { right: `min(${16 / 16}rem, ${16 / 360 * 100}vw)` },
        updateOnMove: true, // is-activeクラスを移動前に更新するかどうかを決定します。
        mediaQuery: 'min',
        breakpoints: {
          768: {
            autoWidth: false,
            perPage: 4,
            gap: `min(${8 / 16}rem, ${8 / 1280 * 100}vw)`,
          }
        }
      }
    }

    this.init();
  }

  init() {
    this.slider.main = new Splide(this.dom.slider.main, this.option.main);
    this.slider.thumbnail = new Splide(this.dom.slider.thumbnail, this.option.thumbnail);

    this.slider.main.sync(this.slider.thumbnail);
    this.slider.main.mount();
    this.slider.thumbnail.mount();
  }

  destroy() {
    if (this.slider.main) this.slider.main.destroy();
    if (this.slider.sub) this.slider.sub.destroy();
  }
}

export default OfficeSlides